import { render, staticRenderFns } from "./transportCar.vue?vue&type=template&id=054840a4&scoped=true&"
import script from "./transportCar.vue?vue&type=script&lang=js&"
export * from "./transportCar.vue?vue&type=script&lang=js&"
import style0 from "./transportCar.vue?vue&type=style&index=0&id=054840a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054840a4",
  null
  
)

export default component.exports